import React from "react";

import RDesc from "./RDesc";
import Info from "./Info";
import Subheader from "./Subheader";
import { Helmet, HelmetProvider } from "react-helmet-async";


const RechargeHome = () => {

  return (
    <HelmetProvider>
      <Helmet>
        <title>BillDrive - Insurance Cashback</title>
        <meta property="title" content="BillDrive - Insurance Cashback. Get More Rewards" /> 
        <meta name="description" content="Insurance Cashback: Earn while you protect. Discover how to safeguard your future and get rewarded with cashback on your insurance premiums" />
        <meta property="og:title" content="BillDrive - Insurance Cashback. Get More Rewards" />
        <meta name="og:description" content="Insurance Cashback: Earn while you protect. Discover how to safeguard your future and get rewarded with cashback on your insurance premiums" />
        <meta property="og:url" content="https://billdrive.in/" />
        <meta property="twitter:title" content="BillDrive - Insurance Cashback. Get More Rewards" />
        <meta name="twitter:description" content="Insurance Cashback: Earn while you protect. Discover how to safeguard your future and get rewarded with cashback on your insurance premiums" />
      </Helmet>  
      <RDesc />  
      <Subheader/>
      <Info />  
    </HelmetProvider>
  );
};

export default RechargeHome;
